import script from "./EmailVerifyView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailVerifyView.vue?vue&type=script&setup=true&lang=js"

import "./EmailVerifyView.vue?vue&type=style&index=0&id=002bd169&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-002bd169"]])

export default __exports__